import MapPinIcon from 'assets/icons/map-pin.svg?react';
import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { Talent } from '@libs/graphql-types';
import { formatRate } from '@libs/ui/components/job/utils/common';

interface MainInfoProps {
  talent: Talent;
}

const useStyles = makeStyles((theme) => ({
  value: {
    fontWeight: 400,
  },
  noWrap: {
    whiteSpace: 'nowrap',
  },
  mainContainer: {
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
      textAlign: 'center',
    },
  },
  infoItem: {
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(1),
    },
  },
}));

const MainInfo = ({ talent }: MainInfoProps) => {
  const { t } = useTranslation('workforce');
  const classes = useStyles();
  const location = talent.location;
  const rate = talent.rate;

  if (!rate && !location) {
    return <></>;
  }

  return (
    <Grid container spacing={4} className={classes.mainContainer}>
      {!!talent.rate && (
        <Grid item className={classes.infoItem}>
          <Typography color="text.secondary" variant="subtitle2">
            {t('talentCard.hourlyRate')}{' '}
            <span className={classes.value}>
              {formatRate({
                min: talent.rate,
                currency: talent.currency,
              })}
            </span>
          </Typography>
        </Grid>
      )}
      {talent.location && (
        <Grid className={cn(classes.noWrap, classes.infoItem)} item>
          <Grid spacing={1} container justifyContent="center">
            <Grid item>
              <MapPinIcon width={15} />
            </Grid>
            <Grid item>
              <Typography
                component="span"
                fontWeight={500}
                color="text.secondary"
                variant="subtitle2"
              >
                {talent.location}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default MainInfo;
